module.exports = __webpack_public_path__ + "static/media/dollar_coin_bronze_h.944780fb.png";